import { type ErrorResponse, type Action, type AsyncStateObject } from '../../../interfaces'
import { APP_ACTION_STATUS, COMMON_ACTIONS, FEEDBACK_ACTIONS } from '../../../utils/constants'

const INITIAL_STATE: AsyncStateObject<ErrorResponse> = {
  data: { message: '' },
  isLoading: false,
  status: APP_ACTION_STATUS.INITIAL,
  error: undefined
}

const giveCoachFeedbacksReducer = (
  state = INITIAL_STATE,
  action: Action<ErrorResponse>
): AsyncStateObject<ErrorResponse> => {
  switch (action.type) {
    case FEEDBACK_ACTIONS.ADD_COACH_FEEDBACK_TO_COACHEES + COMMON_ACTIONS.REQUEST:
      return {
        ...state,
        isLoading: true,
        status: APP_ACTION_STATUS.LOADING,
        error: undefined
      }
    case FEEDBACK_ACTIONS.ADD_COACH_FEEDBACK_TO_COACHEES + COMMON_ACTIONS.SUCCESS:
      return {
        ...state,
        isLoading: false,
        status: APP_ACTION_STATUS.SUCCESS,
        data: action.data
      }
    case FEEDBACK_ACTIONS.ADD_COACH_FEEDBACK_TO_COACHEES + COMMON_ACTIONS.ERROR:
      return {
        ...state,
        isLoading: false,
        data: { message: '' },
        status: APP_ACTION_STATUS.ERROR,
        error: action.error
      }
    case FEEDBACK_ACTIONS.ADD_COACH_FEEDBACK_TO_COACHEES + COMMON_ACTIONS.CLEAR:
      return INITIAL_STATE
    default:
      return state
  }
}

export default giveCoachFeedbacksReducer
